module.exports = function getResource(label) {
    const resources = {
        signIn: 'Sign In',
        sigInToSeeItems: 'Sign in to see items you may have added previously.',
        seeSamplesRewardsPromotions: 'See samples, rewards, and promos in',
        basket: 'basket',
        dcTotal: 'Get It Shipped ',
        basketTotal: 'Subtotal ',
        reserveTotal: 'Reserve & Pick Up ',
        bopisTotal: 'Buy Online & Pick Up ',
        checkout: 'View Basket & Checkout',
        emptyBasket: 'Your basket is empty.',
        item: 'item',
        or: 'or',
        shopNewArrivals: 'Shop New Arrivals',
        viewAll: 'View all',
        freeShipping: 'Free Shipping',
        createAccount: 'Create Account',
        basketHeader: 'Get It Shipped',
        reserveHeader: 'Reserve & Pick Up',
        bopisHeader: 'Buy Online & Pick Up',
        sameDayDelivery: 'Same-Day Delivery',
        standardDelivery: 'Standard',
        getBackToYourBasket: 'Get Back to Your Basket'
    };

    return resources[label];
};
